import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const AddPanModal = ({ buttonComponent, agentId, callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => { setShow(false) };
    const handleShow = () => setShow(true);

    async function add() {
        loadingShow();
        let postData = {
            "pan": document.getElementById('pan').value?.trim() || ''
        };
        let resp = await postApi(postData, urlApi?.addPanNumberOfAgent + agentId);
        loadingHide();
        if (resp.responseCode === 200) {
            callback?.();
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }

    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add/Update PAN Number</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="top-label-input-group mb-2">
                        <label htmlFor="pan" className='text-sm font-semibold mb-1'>PAN Number*</label>
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='pan' />
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddPanModal